import { css } from '@compiled/react';

import { Card } from './components/card';
import { JiraIssue } from './constants/types';
import { colors } from './helpers/colors';

interface ColumnProps {
	displayMode?: 'animated' | 'static';
	layoutMode?: 'legacy' | 'fixed-scene';
	title: string;
	cards: JiraIssue[];
}
const columnStyle = css({
	backgroundColor: colors.elevationSurfaceSunken,
	borderRadius: '8px',
	flex: '1 1 0',
	paddingInlineStart: '5px',
	paddingInlineEnd: '5px',
	minHeight: '622px',
});
const columnTitleStyle = css({
	backgroundColor: colors.elevationSurfaceSunken,
	color: colors.textSubtle,
	display: 'block',
	fontSize: '12px',
	fontWeight: '600',
	padding: '16px',
	textTransform: 'uppercase',
	margin: '0px',
	lineHeight: '1.33333333',
});
const listStyle = css({
	display: 'flex',
	flexDirection: 'column-reverse',
});

export const Column = ({ title, cards, displayMode, layoutMode }: ColumnProps) => {
	const Title = layoutMode === 'fixed-scene' ? 'div' : 'h3';
	return (
		<div css={columnStyle}>
			<Title
				css={columnTitleStyle}
				role={layoutMode === 'fixed-scene' ? 'heading' : undefined}
				aria-level={layoutMode === 'fixed-scene' ? 3 : undefined}
			>
				{title}
			</Title>
			<div css={listStyle} role="list">
				{cards.map((card, i) => {
					return (
						card.id && (
							<Card
								displayMode={displayMode}
								key={i}
								role="listitem"
								priority={card.priority}
								epicName={card.epicName}
								assignee={card.assignee}
								issueType={card.issueType}
								summary={card.summary}
								id={card.id}
							/>
						)
					);
				})}
			</div>
		</div>
	);
};
